<template>
<div id="sutra02">

  <h2 class="pageTitle">{{$t('avatamsaka.sutra02.title')}}</h2>

  <div class="sectionIntro">
      <div class="sectionBack">
      </div>
      <div class="introBook">
        <img src="@/../static/image/content/sutras/sutra02.png" />
      </div>
      <div class="introContent">
        <p v-html="$t('avatamsaka.sutra02.topIntro')"></p>
        <p class="">
          {{$t('avatamsaka.reference.title')}}<br/>
          {{$t('avatamsaka.sutra02.topIntroRef')}}
        </p>
      </div>
    </div>

</div>
</template>

<script>

export default {
  name: 'theTenBhumis',
  data() {
    return {
    };
  },
  methods: {
    getArticlePath(vId) {
      this.$router.push({
        name: 'article',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
    getContraPath(vId) {
      this.$router.push({
        name: 'contra',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
    getCategoryPath(vId) {
      this.$router.push({
        name: 'categorySutra',
        params: {
          sid: 1,
          vid: vId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#sutra02 {

  .pageTitle {
    line-height: 1.8em;
    background-color: #e0e7c8;
    border-top: 2em solid #e0e7c8;
    font-size: 2em;
    margin: 0px;
  }

  .areaTitle {
    margin-top: 10em;
    margin-bottom: 4em;
    border-top: 3px solid #eed85e;
    background: #0d685c;
    height: 0.4em;
    display: flex;
    align-items: center;
    .caption {
      font-size: 1.5em;
      display: flex;
      align-items: center;
      justify-content: center;
        span {
          font-weight: bolder;
          font-size: 1em;
          align-self: center;
          background: #ffffff;
          border-left: #ffffff solid 1.1em;
          border-right: #ffffff solid 1.1em;
        }
      padding: 10px;
      flex: 1;
    }
  }

  .sectionIntro {
    display: flex;
    position: relative;


  .sectionBack {
    position: absolute;
    width: 100%;
    height: 0;
    border-top: 500px solid #e0e7c8;
    border-right: 100vw solid transparent;
  }

  .introBook {
    position: sticky;
    flex: 1.5;
    padding-top: 20px;
    margin: 40px;
    img {
      width: 100%;
    }
  }
  .introContent {

    position: sticky;
    flex: 2;
    background-color: rgba(255, 255, 255, 0.8);
    margin: 40px;
    margin-top: 60px;
    margin-right: 60px;
    padding: 0px 20px;
    text-align: left;
    p {
      padding: 1.5em;
    }
    @media (max-width: 768px) {
        h2 {
          text-align: center;
        }
        button {
          display: block;
          margin: 0 auto;
        }
    }
  }

  @media (max-width: 768px) {

      display: block;
      flex-direction: row;

      .introBook, .introContent {
        clear: both;
        display: block;
        width: 100%;
        flex: none;
        margin: 0px;
        padding: 40px;
      }

      .introBook {
        position: relative;
        margin: 0;
        img {
          width: 100%;
          max-height: none;
        }
      }
  }
}


  .sectionVersion {

    flex-direction: row;
    margin-top: 1em;

    .versionGroup {
      display: flex;
      flex-direction: column;

    .version {
      color: #0f3f3f;
      margin: 30px;
      padding: 20px;
      height: auto;
      flex: 1;
      display: flex;
      position: relative;
      .content {
        width: 100%;
        flex-direction: column;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 1.3em;
        font-weight: 400;
        float: left;
        align-items: center;
        h2{
          padding: 0;
          font-weight: bold;
          margin-bottom: 0px;
          font-size: 1em;
          margin-left: -0.5em;
        }
        h2:hover {
          cursor: pointer;
        }
        p{
          padding: 0px;
          margin: 0px;
          font-size: 0.7em;
        }
      }
      .imgContent {
        display: block;
        width: 15em;
        img {
          width: auto;
          max-height: 15em;
        }
        float: left;
      }
    }
}

  }

  @media (max-width: 1024px) {

      .versionContent {
        .pageTitle {
          text-shadow: 1px 1px 10px #ffffff, 1px 1px 10px #ffffff
            , 1px 1px 10px #ffffff, 1px 1px 10px #ffffff;
          font-weight: 500;
          // background: #ffffff60;
          margin-top: 0px;
          background: rgba(255, 255, 255, 0.4);
          background-clip: padding-box;
          border-top: 1.7em solid transparent;
          margin-bottom: 0px;
        }
      }

      h2 {
        text-align: center;
      }

      button {
        display: block;
        margin: 20px auto;
      }

      .sectionIntro {

        .introCover {
          position: absolute;
          right: 0;
          padding: 0px;
          margin: 0px;
          img {
            max-width: 500px;
            width: 100%;
            float: right;
          }
        }
        .introContent {
          > h2 {
            margin-left: 0px;
            display: none;
          }

          p {
            font-size: 0.8em;
            margin: 0px;
            padding: 0px 2em;
            overflow: scroll;
            position: relative;
            line-height: 1.2em;
            max-height: 15.6em;
            margin-right: -0.9em;
            padding-right: 0.9em;
          }

          position: sticky;
          flex: 2;
          padding: 0px;
          z-index: 1;
          margin: 20px;
          margin-top: 0px;
          text-align: left;
          align-self: center;

          .versionGroup {
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }


      .sectionVersion {

        margin-top: 0px;

        .versionGroup {
          height: 100%;
          width: 100%;

          display: grid;
          width: 100%;
        .version {
          margin: 30px;
          margin-top: 0px;
          padding: 20px;
          height: auto;
          position: relative;

          .content {

            padding: 0px;
            width: calc(100% - 128px);
            overflow: hidden;
            float: left;
            h2{
              padding-bottom: 0px;
              font-weight: bold;
              font-size: 0.9em;
              margin-bottom: 0px;
            }
            h2:hover {
              cursor: pointer;
            }
            p {

              font-size: 0.8em;
              margin: 0px;
              padding: 0px;

              overflow: hidden;
              position: relative;
              line-height: 1.2em;
              max-height: 12em;
              margin-right: -0.9em;
              padding-right: 0.9em;
            }
            p:before {

              content: '...';

              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .imgContent {
            padding-right: 0px;
            width: 128px;
            height: 200px;
            float: left;
            img {
              width: auto;
              height: calc(100% - 20px);
            }
          }
        }
    }

    :first-child {
      .version:first-child {
        margin-top: 30px;
      }
    }

      }


  }

  @media (max-width: 768px) {
    .pageTitle {
      font-size: 1.6em;
    }

    .sectionIntro {
      .introBook {
        padding: 1.5em;
      }
    }

    .sectionIntro {
      font-size: 0.9em;
      .introContent {
        margin: 0px;
        padding: 0px;
        overflow: none;
        font-size: 1.3em;
        margin: 0px;
        padding: 0px;
        background: transparent;
        p {
          overflow: none;
          max-height: none;
          margin: 0px;
          padding: 1.5em;
          line-height: 1.8em;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Sutra02.vue